import { IBaseDisplayTicketItem } from '../interfaces/IDisplayTicket';
import { OrderStatusEnum } from '../enums/OrderStatusEnum';

export function applyCascateTicketSubItemStatusChange(
  subItems: IBaseDisplayTicketItem[],
  status: OrderStatusEnum
): IBaseDisplayTicketItem[] {
  return (
    subItems?.map((subitem) => {
      return {
        ...subitem,
        status,
      };
    }) || []
  );
}
